/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loginsubmit1Inputs */

const en_loginsubmit1 = /** @type {(inputs: Loginsubmit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send sign-in link`)
};

const pt_loginsubmit1 = /** @type {(inputs: Loginsubmit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar link de acesso`)
};

/**
* | output |
* | --- |
* | "Send sign-in link" |
*
* @param {Loginsubmit1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const loginsubmit1 = /** @type {((inputs?: Loginsubmit1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loginsubmit1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loginsubmit1(inputs)
	return pt_loginsubmit1(inputs)
});
export { loginsubmit1 as "loginSubmit" }